import { render, staticRenderFns } from "./predictIds.vue?vue&type=template&id=216e83ee&scoped=true&"
import script from "./predictIds.vue?vue&type=script&lang=js&"
export * from "./predictIds.vue?vue&type=script&lang=js&"
import style0 from "./predictIds.vue?vue&type=style&index=0&id=216e83ee&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216e83ee",
  null
  
)

export default component.exports